(function () {
    'use strict';

    angular.module('core')
        .service('dialogService', ['ngDialog', function (ngDialog) {

            function resolve(primary, def) {
                if (angular.isDefined(primary) && primary !== null) {
                    return primary;
                } else {
                    return def;
                }
            }

            return {
                error: function (text, title, ok) {
                    ngDialog.open({
                        template: 'layout/dialogs/error.html',
                        className: 'ngdialog-theme-default',
                        data: {
                            text: text,
                            title: resolve(title, 'Klaida'),
                            ok: resolve(ok, 'Uždaryti')
                        }
                    });
                },
                success: function (text, title, ok) {
                    ngDialog.open({
                        template: 'layout/dialogs/success.html',
                        className: 'ngdialog-theme-default',
                        data: {
                            text: text,
                            title: resolve(title, 'Gerai'),
                            ok: resolve(ok, 'Uždaryti')
                        }
                    });
                },
                confirm: function (text, title, ok, cancel) {
                    return ngDialog.openConfirm({
                        template: 'layout/dialogs/confirm.html',
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        data: {
                            text: text,
                            title: resolve(title, 'Patvirtinimas'),
                            ok: resolve(ok, 'Patvirtinti'),
                            cancel: resolve(cancel, 'Atšaukti')
                        }
                    });
                },
                confirmCustom: function (templateUrl, params) {
                    return ngDialog.openConfirm({
                        template: templateUrl,
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        data: {
                            params: params
                        }
                    });
                },
                blockingDialog: function(promise, title, initialText, clazz) {
                    return ngDialog.open({
                        template: 'layout/dialogs/blockingDialog.html',
                        className: 'ngdialog-theme-default',
                        appendClassName: clazz,
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: resolve(initialText, ''),
                            title: resolve(title, 'Prašome palaukti...'),
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            $scope.ngDialogData.promise.then(
                                function(success) {
                                    var timeout = success == null ? 0 : 2000;
                                    $scope.ngDialogData.text = resolve(success, $scope.text);
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    setTimeout(function() {
                                        $scope.closeThisDialog();
                                    }, timeout);
                                },
                                function(fail) {
                                    $scope.ngDialogData.text = resolve(fail, $scope.text);
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                },
                                function(progress) {
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                        }]
                    });
                },
                customBlockingDialog: function(template, args, promise, title, initialText, clazz) {
                    return ngDialog.open({
                        template: template,
                        className: 'ngdialog-theme-default',
                        appendClassName: clazz,
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: resolve(initialText, ''),
                            title: resolve(title, 'Prašome palaukti...'),
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            args['$scope'] = $scope;
                            $scope.ngDialogData.promise.then(
                                function(success) {
                                    if(args['success']) {
                                        args['success'](success);
                                        return;
                                    }
                                    var timeout = success == null ? 0 : 2000;
                                    $scope.ngDialogData.text = resolve(success, $scope.text);
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    setTimeout(function() {
                                        $scope.closeThisDialog();
                                    }, timeout);
                                },
                                function(fail) {
                                    if(args['fail']) {
                                        args['fail'](fail);
                                        return;
                                    }
                                    $scope.ngDialogData.text = resolve(fail, $scope.text);
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                },
                                function(progress) {
                                    if(args['progress']) {
                                        args['progress'](progress);
                                        return;
                                    }
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                            $scope.get = function(name) {
                                return args[name];
                            };
                        }]
                    });
                },
                reportExportBlockingDialog: function(promise) {
                    return ngDialog.open({
                        template: 'layout/dialogs/blockingDialog.html',
                        className: 'ngdialog-theme-default',
                        closeByDocument: false,
                        closeByEscape: false,
                        showClose: false,
                        data: {
                            text: 'Prašome palaukti...',
                            title: 'Failas ruošiamas',
                            promise: promise
                        },
                        controller: ['$scope', function($scope) {
                            $scope.ngDialogData.promise.then(
                                function() {
                                    $scope.showClose = true;
                                    $scope.success = true;
                                    $scope.closeThisDialog();
                                },
                                function() {
                                    $scope.showClose = true;
                                    $scope.fail = true;
                                    $scope.closeThisDialog();
                                },
                                function(progress) {
                                    $scope.ngDialogData.text = resolve(progress, $scope.text);
                                }
                            );
                        }]
                    });
                }
            };
        }]);

})();
